export const WORNING_BLUE = '#2552DC';
export const WORNING_YELLOW = '#F8D515';
